import type { ExerciseSection, ExerciseSetQuestionView } from '../api/content.types';
import type { ExerciseAttemptSummary } from '../api/progress.types';

/// Logic thuần cho tab "Lịch sử" của dialog Bài tập — bản sao của
/// apps/mobile/src/screens/hoc/exerciseHistoryFormat.ts, sửa một chỗ thì sửa cả hai.

/** Vòng % viền xanh lá khi đạt ngưỡng này, dưới ngưỡng viền xanh CTA (thiết kế: 83% xanh lá, 67% xanh CTA). */
export const HIGH_SCORE_PCT = 80;

export function scorePct(correct: number, total: number): number {
  return total > 0 ? Math.round((correct / total) * 100) : 0;
}

const pad = (n: number) => String(n).padStart(2, '0');

/** "Hôm nay" / "Hôm qua" / "21/10" (cùng năm) / "21/10/2025". */
export function formatDay(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOf(now) - startOf(d)) / (24 * 60 * 60 * 1000));
  if (diffDays === 0) return 'Hôm nay';
  if (diffDays === 1) return 'Hôm qua';
  const dm = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
  return d.getFullYear() === now.getFullYear() ? dm : `${dm}/${d.getFullYear()}`;
}

/** "14′" — dưới 1 phút hiện giây "45″" để lượt làm nhanh không thành "0′". */
export function formatDuration(seconds: number): string {
  return seconds < 60 ? `${seconds}″` : `${Math.round(seconds / 60)}′`;
}

/** "Hôm nay · 09:12 · 14′" — bỏ phần thời lượng nếu lượt không có (client cũ không gửi). */
export function formatAttemptMeta(attempt: Pick<ExerciseAttemptSummary, 'submittedAt' | 'durationSeconds'>, now = new Date()): string {
  const d = new Date(attempt.submittedAt);
  const parts = [formatDay(attempt.submittedAt, now), `${pad(d.getHours())}:${pad(d.getMinutes())}`];
  if (attempt.durationSeconds != null) parts.push(formatDuration(attempt.durationSeconds));
  return parts.join(' · ');
}

/**
 * Khoảng câu [lo,hi) để "Làm lại đề này" mở đúng phần user đã làm ở lượt đó —
 * lượt luôn là 1 dải liên tục (cả đề hoặc 1 phần), nên lấy từ câu đầu của phần
 * đầu tới câu cuối của phần cuối. null nếu không khớp được câu nào.
 */
export function retryRange(questions: ExerciseSetQuestionView[], sections: ExerciseSection[]): { lo: number; hi: number } | null {
  const indices = questions.map((q, i) => (sections.includes(q.section) ? i : -1)).filter((i) => i >= 0);
  if (indices.length === 0) return null;
  return { lo: indices[0], hi: indices[indices.length - 1] + 1 };
}
